import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { bodySmall, bodySmall2 } from '@/styles/typography';
import { flex } from '@/styles/layout';

export const DropZone = styled.label<{ $active?: boolean }>`
  ${bodySmall};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 140px;
  border: 2px dashed ${({ $active }) => ($active ? COLORS.blue[500] : COLORS.grey[400])};
  border-radius: 12px;
  background: ${({ $active }) => ($active ? COLORS.blue[200] : COLORS.grey[100])};
  cursor: pointer;
  text-align: center;

  input {
    display: none;
  }
`;

export const KeyValueList = styled.dl`
  ${bodySmall};
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  gap: 6px 16px;
  margin: 0;

  dt {
    color: ${COLORS.grey[600]};
  }

  dd {
    margin: 0;
    word-break: break-word;
  }
`;

export const QrBox = styled.div`
  width: 160px;
  height: 160px;
  border: 1px solid ${COLORS.grey[600]};
  border-radius: 8px;
  padding: 8px;
  background: ${COLORS.white};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const SnippetBox = styled.pre`
  ${bodySmall2};
  margin: 0;
  padding: 20px 16px;
  border-radius: 8px;
  white-space: pre-wrap;
  word-break: break-all;
  font-family: 'JetBrainsMono-Regular', 'SFMono-Regular', Menlo, monospace;
  background-color: ${COLORS.grey[150]};
  border: 1px solid ${COLORS.grey[400]};
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px solid ${COLORS.grey[400]};

  &:last-child {
    border-bottom: 0;
  }
`;

export const PreviewFrame = styled.div`
  border: 1px solid ${COLORS.grey[200]};
  border-radius: 12px;
  padding: 16px;
  background: ${COLORS.grey[100]};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InvoiceAccountList = styled.div`
  ${flex({ flexDirection: 'column' })};
  gap: 10px;
  max-height: 312px;
  flex: 1;
  overflow: auto;
  padding: 12px;
  border: 1px solid ${COLORS.grey[400]};
  background-color: #fafafa;
  border-radius: 8px;
`;

export const InvoiceAccountCard = styled.button<{ $active?: boolean; $locked?: boolean }>`
  ${flex({ alignItems: 'center' })}
  gap: 8px;
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid ${({ $active }) => ($active ? COLORS.green[500] : COLORS.grey[300])};
  box-shadow: ${({ $active }) => ($active ? `0 0 0 1px ${COLORS.green[600]}` : 'none')};
  background: ${({ $active, $locked }) => ($locked ? COLORS.grey[150] : $active ? COLORS.green[50] : COLORS.white)};
  cursor: ${({ $locked }) => ($locked ? 'default' : 'pointer')};
  text-align: left;
`;
